/* ------------------------------------- MATERIAL UI --------------------------------------- */
import { Chip, Container, Grid, Stack } from '@mui/material';

/* ------------------------------------- DEPENDENCIES -------------------------------------- */
import { useSnackbar } from 'notistack';

/* ------------------------------------- REACT JS ------------------------------------------ */
import React from 'react';
import { useEffectAsync } from '../reactHelper';
import { getItem } from '../fetch';

/* ------------------------------------- COMPONENTS ---------------------------------------- */
import Page from '../components/Page';
import { SubscriptionHead, SubscriptionPlan } from '../components/subscription';
import { useTranslation } from '../common/LocalizationProvider';

export default function Subscription() {
  const t = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const [tiers, setTiers] = React.useState(null);
  const [currency, setCurrency] = React.useState('EUR');

  useEffectAsync(async () => {
    const response = await getItem('abonnement/products');
    if (response.ok) {
      setTiers(await response.json());
    } else {
      const message = await response.text();
      enqueueSnackbar(message.slice(0, message.indexOf('-')), { variant: 'error' });
    }
  }, []);

  return (
    <Page title={t('sub_Title')}>
      <Container>
        <SubscriptionHead />

        <Stack direction="row-reverse" spacing={1} mb={5}>
          <Chip
            label="$ - USD"
            variant={currency === 'USD' ? 'filled' : 'outlined'}
            onClick={() => setCurrency('USD')}
            color="primary"
          />
          <Chip
            label="€ - EUR"
            variant={currency === 'EUR' ? 'filled' : 'outlined'}
            onClick={() => setCurrency('EUR')}
            color="primary"
          />
        </Stack>
        {tiers !== null && (
          <Grid container spacing={3}>
            <Grid item xs={12} sm={4} md={4}>
              <SubscriptionPlan />
            </Grid>
            {tiers
              .sort((a, b) => (parseInt(a.eurPrice, 10) > parseInt(b.eurPrice, 10) ? 1 : -1))
              .map((tier, index) => (
                <Grid item xs={12} sm={4} md={4} key={index}>
                  <SubscriptionPlan tier={tier} currency={currency} />
                </Grid>
              ))}
          </Grid>
        )}
      </Container>
    </Page>
  );
}
